<script>
//import MetisMenu from "metismenujs/dist/metismenujs";
//import simplebar from "simplebar-vue";
//import { authHeader } from '../helpers/fakebackend/auth-header';
//import Menu from "./menu";
//import { menuItems } from "./menu";

import store from "@/state/store";
import axios from "axios";

/**
 * Sidebar component
 */
export default {
  data() {
    return {
      // menuItems: [ { "id": 7, "label": "Menu", "link": "",  "icon": "", "isTitle": true, "subItems": [] }, { "id": 1, "label": "Dashboard88888", "link": "/form/companyForm",  "icon": "uil-home-alt", "isTitle": false, "subItems": [] }],//[{id:7,label:"Menu",link:"",parentMenuId:0,icon:"",isTitle:true,subItems:[]},{"id":1,"label":"Dashboard","link":"/form/companyForm","parentMenuId":0,"icon":"uil-home-alt","isTitle":false,"subItems":[]}],
      //menuItems:menuItems,//[{id:7,label:"Menu",link:"",parentMenuId:0,icon:"",isTitle:true,subItems:[]},{"id":1,"label":"Dashboard","link":"/form/companyForm","parentMenuId":0,"icon":"uil-home-alt","isTitle":false,"subItems":[]},{"id":2,"label":"Restaurant","link":"","parentMenuId":0,"icon":"","isTitle":true,"subItems":[]},{id:3,label:"Company",link:"",parentMenuId:0,icon:"uil-bag",isTitle:false,subItems:[{id:5,label:"Register Company",link:"/form/companyForm",parentMenuId:3,icon:""},{"id":6,"label":"View Company","link":"/tables/companyTable","parentMenuId":3,"icon":""}]},{"id":8,"label":"Restaurant Brand","link":"/tables/restaurantTable","parentMenuId":0,"icon":"uil-shop","isTitle":false,"subItems":[{"id":9,"label":"Register Brand","link":"/form/restaurantForm/:0","parentMenuId":8,"icon":""},{"id":10,"label":"View Brand","link":"/tables/restaurantTable","parentMenuId":8,"icon":""}]},{"id":11,"label":"Restaurant Branches","link":"","parentMenuId":0,"icon":"uil-store","isTitle":false,"subItems":[{"id":12,"label":"Register Branch","link":"/form/restaurantBranchForm","parentMenuId":11,"icon":""},{"id":13,"label":"View Branch","link":"/tables/restaurantBranchTable","parentMenuId":11,"icon":""}]},{"id":14,"label":"Restaurant Menu","link":"/tables/restaurantBranchTable","parentMenuId":0,"icon":"uil-restaurant","isTitle":false,"subItems":[{"id":15,"label":"Add Menu","link":"/form/restaurantMenuForm","parentMenuId":14,"icon":""},{"id":16,"label":"View Menu","link":"/tables/restaurantMenuTable","parentMenuId":14,"icon":""},{"id":17,"label":"Add Addons","link":"/form/addonsForm","parentMenuId":14,"icon":""},{"id":18,"label":"View Addons","link":"/tables/addonsTables","parentMenuId":14,"icon":""}]},{"id":19,"label":"Categories","link":"","parentMenuId":0,"icon":"uil-store","isTitle":false,"subItems":[{"id":20,"label":"Add Category","link":"/form/categoryForm","parentMenuId":19,"icon":""},{"id":21,"label":"View Category","link":"/tables/categoryTable","parentMenuId":19,"icon":""}]}],//[],//menuItems,
      menuItems: [],
      userData: "",
      menu: [],
      menuData: [
        {
          "label": "Menu",
          "link": null,
          "isTitle": true,
          "subItems": [],
        },
        {
          "label": "Dashboard",
          "link": "/dashboard/defaultDashboard",
          "icon": "uil-home-alt",
          "isTitle": false,
          "subItems": [],
          "gate": "default dashboard access"
        },
        {
          "label": "Dashboard",
          "link": "/dashboard/superAdminDashboard",
          "icon": "uil-home-alt",
          "isTitle": false,
          "subItems": [],
          "gate": "admin dashboard access"
        },
        {
          "label": "Dashboard",
          "link": "/dashboard/restaurantDashboard",
          "icon": "uil-home-alt",
          "isTitle": false,
          "subItems": [],
          "gate": "restaurant dashboard access"
        },
        {
          "label": "Dashboard",
          "link": "/dashboard/corporateDashboard",
          "icon": "uil-home-alt",
          "isTitle": false,
          "subItems": [],
          "gate": "corporate dashboard access"
        },
        {
          "label": "Dashboard",
          "link": "/dashboard/principleDashboard",
          "icon": "uil-home-alt",
          "isTitle": false,
          "subItems": [],
          "gate": "principle dashboard access"
        },
        {

          "label": "Restaurant",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "restaurant access",
        },
        {
          "label": "Food Company",
          "link": null,
          "icon": "uil-bag",
          "isTitle": false,
          "gate": "food company access",
          "subItems": [
            {
              "label": "Register Food Company",
              "link": "/form/companyForm/:type",
              "gate": "create food company",
            },
            {
              "label": "View Food Companies",
              "link": "/tables/companyTable",
              "gate": "list food company",
            }
          ],
        },
        {

          "label": "Restaurant Brand",
          "link": "/tables/restaurantTable",
          "icon": "uil-shop",
          "isTitle": false,
          "gate": "restaurant brand access",
          "subItems": [
            {

              "label": "Register Brand",
              "link": "/form/restaurantForm/:type",
              "gate": "create restaurant brand",

            },
            {

              "label": "View Brand",
              "link": "/tables/restaurantTable",
              "gate": "list restaurant brand",

            }
          ]
        },
        {

          "label": "Restaurant Branches",
          "link": null,
          "icon": "uil-store",
          "isTitle": false,
          "gate": "restaurant branch access",
          "subItems": [
            {

              "label": "Register Branch",
              "link": "/form/restaurantBranchForm/:type",
              "gate": "create restaurant branch",

            },
            {
              "label": "View Branches",
              "link": "/tables/restaurantBranchTable",
              "gate": "view restaurant branch",
            },
            {
              "label": "View License",
              "link": "/restaurant/license",
              "gate": "view restaurant license",
            }
          ]
        },
        {
          "label": "Restaurant Details",
          "link": "/profile/restaurantDetails",
          "icon": "uil-file-landscape-alt",
          "isTitle": false,
          "gate": "restaurant details access",
          "subItems": [],

        },
        {
          "label": "Restaurant Menu",
          "link": "",
          "icon": "uil-restaurant",
          "isTitle": false,
          "gate": "restaurant menu access",
          "subItems": [
            {

              "label": "Add Food Item",
              "link": "/form/restaurantMenuForm/:type",
              "gate": "create food item",

            },
            {
              "label": "View Menu",
              "link": "/tables/restaurantMenuTable",
              "gate": "list menu",

            },
            {
              "label": "Add Addons",
              "link": "/form/addonsForm/:type",
              "gate": "create addons",

            },
            {
              "label": "View Addons",
              "link": "/tables/addonsTables",
              "gate": "list addons",

            },
            {

              "label": "Add Restaurant Category",
              "link": "/form/restaurantCategoryForm",
              "gate": "create restaurant category",

            },
            {

              "label": "View Restaurant Category",
              "link": "/tables/restaurantCategoryTable",
              "gate": "view restaurant category",

            }
          ],

        },
        {

          "label": "Food Courts",
          "link": null,
          "icon": "uil-store-alt",
          "isTitle": false,
          "gate": "food court access",
          "subItems": [
            {

              "label": "Add Food Court",
              "link": "/form/foodCourtForm/:type",
              "gate": "create food court",

            },
            {

              "label": "View Food Court",
              "link": "/tables/foodCourtTable",
              "gate": "list food court",

            }
          ]

        },
        {

          "label": "Operational Checklist",
          "link": null,
          "icon": "uil-notes",
          "isTitle": false,
          "gate": "operational checklist access",
          "subItems": [
            {
              "label": "Create Template",
              "link": "/form/complianceTemplate/:type",
              "gate": "create operational checklist template",


            },
            {
              "label": "View Template",
              "link": "/tables/complianceTemplateTable",
              "gate": "list operational checklist template",
            },
            {

              "label": "View Operational Checklist",
              "link": "/tables/operationalChecklistTable",
              "gate": "list operational checklist",

            }
          ]
        },
        {
          "label": "Discount & Coupons",
          "link": null,
          "icon": "uil-ticket",
          "isTitle": false,
          "gate": "discount and coupon access",
          "subItems": [
            {
              "label": "Create Discount",
              "link": "/form/discountForm",
              "gate": "create discount",
            },
            {
              "label": "View Discount",
              "link": "/tables/discountTable",
              "gate": "list discount",

            }
          ],

        },
        {
          "label": "Pre-buy Voucher",
          "link": null,
          "icon": "fas fa-ticket-alt",
          "isTitle": false,
          "gate": "pre-buy voucher access",
          "subItems": [
            {
              "label": "Add Pre-buy Voucher Plan",
              "link": "/form/preBuyVoucherForm",
              "gate": "create voucher plan",
            },
            {
              "label": "View Pre-buy Voucher Plan",
              "link": "/tables/preBuyVoucherTable",
              "gate": "list voucher plan",

            }
          ],

        },
        {
          "label": "Purchase Pre-buy",
          "link": null,
          "icon": "far fa-money-bill-alt",
          "isTitle": false,
          "gate": "pre-buy purchase access",
          "subItems": [
            {
              "label": "View Purchase Plans",
              "link": "/tables/purchasedVoucherPlanTable",
              "gate": "list voucher purchase plan",
            },
            {
              "label": "View Purchase Vouchers",
              "link": "/tables/purchasedVouchersTable/:type",
              "gate": "list purchase voucher",

            }
          ],

        },
        {
          "label": "Corporates",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "corporate menu access"
        },
        {
          "label": "Corporates",
          "link": null,
          "icon": "uil-bag",
          "isTitle": false,
          "gate": "corporate access",
          "subItems": [
            {
              "label": "Register Corporate",
              "link": "/form/corporateForm/:type",
              "gate": "create corporate"

            },
            {

              "label": "View Corporate",
              "link": "/tables/corporateTable",
              "gate": "list corporate"
            }
          ],

        },
        {

          "label": "Profile",
          "link": "/profile/corporateProfile",
          "icon": "dripicons-document",
          "isTitle": false,
          "gate": "corporate profile access",
          "subItems": [],
        },
        {

          "label": "Employees",
          "link":null,
          "icon": "fas fa-users",
          "isTitle": false,
          "gate":"corporate employee menu access",
          "subItems": [
            {
              "label": "Add Employees",
              "link": "/form/corporateUsersForm",
              "icon": "",
              "gate":"create corporate employee"
            },
            {
              "label": "View Employees",
              "link": "/tables/usersTable",
              "icon": "",
              "gate":"list corporate employee"
            }
          ],
        },
        {
          "label": "Corporate Branches",
          "link": null,
          "icon": "uil-building",
          "isTitle": false,
          "gate": "corporate branches access",
          "subItems": [
            {
              "label": "Register Corporate Branch",
              "link": "/form/corporateBranchForm",
              "gate": "create corporate branch",

            },
            {
              "label": "View Corporate Branch",
              "link": "/tables/corporateBranchTable",
              "gate": "list corporate branch",
            }
          ]
        },
        {
          "label": "Meal Plan",
          "link": null,
          "icon": "uil-parcel",
          "isTitle": false,
          "gate": "meal plan access",
          "subItems": [
            {

              "label": "Add Meal Plan",
              "link": "/form/corporateMealPlanForm/:type",
              "gate": "create meal plan",

            },
            {
              "label": "View Meal Plan",
              "link": "/tables/corporateMealPlanTable/",
              "gate": "list meal plan",
            }
          ]

        },
        {
          "label": "Principal",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "principle menu access"
        },
        {

          "label": "Principals",
          "link": null,
          "icon": "bx bxs-bank",
          "isTitle": false,
          "gate": "principle access",
          "subItems": [
            {

              "label": "Add Principal",
              "link": "/form/principleForm/:type",
              "gate": "create principle",

            },
            {
              "label": "View Principal",
              "link": "/tables/principleTable",
              "gate": "list principle",

            }
          ]

        },
        {

          "label": "Principal Branches",
          "link": null,
          "icon": "bx bxs-buildings",
          "isTitle": false,
          "gate": "principle branch access",
          "subItems": [
            {
              "label": "Add Principal Branches",
              "link": "/form/principleBranchForm/:type",
              "gate": "create principle branch"

            },
            {

              "label": "View Principal Branches",
              "link": "/tables/principleBranchTable",
              "gate": "list principle branch"

            }
          ],

        },
        {

          "label": "Restaurant List",
          "link": '/tables/principleFoodCourtsTable',
          "icon": "uil-bag",
          "isTitle": false,
          "gate": "restaurant list access",
          "subItems": [
          ],

        },
        {

          "label": "Corporate List",
          "link": '/tables/principleCorporates',
          "icon": "uil-clipboard-notes",
          "isTitle": false,
          "gate": "corporate list access",
          "subItems": [
          ],

        },
        {

          "label": "Orders",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "order menu access",
        },
        {

          "label": "Orders",
          "link": null,
          "icon": "uil-receipt-alt",
          "isTitle": false,
          "gate": "order access",
          "subItems": [
            {
              "label": "Manage Orders",
              "link": "/orders/manageOrders",
              "gate": "manage orders",
            },
            {
              "label": "Order History",
              "link": "/orders/ordersTable",
              "gate": "view order history",
            },
          ],

        },
        {

          "label": "Reports",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "report access",
        },
        {

          "label": "Order Transactions",
          "link": "/orders/orderTransactionTable",
          "icon": "uil-file-check-alt",
          "isTitle": false,
          "gate": "view order transaction",
          "subItems": [],

        },
        {

          "label": "Product Mix Report",
          "link": "/tables/productMixReport",
          "icon": "uil-chart-growth-alt",
          "isTitle": false,
          "gate": "view product mix report",
          "subItems": [],

        },
        {

          "label": "Detailed Meal Plan Report",
          "link": "/tables/mealPlanFullReport",
          "icon": "uil-file-alt",
          "isTitle": false,
          "gate": "view detailed meal plan report",
          "subItems": [],

        },
        {

          "label": "Wallet Master",
          "link": "/tables/walletReport",
          "icon": "uil-chart-line",
          "isTitle": false,
          "gate": "view wallet master",
          "subItems": [],

        },
        {
          "label": "Subsidy Report",
          "link": "/tables/subsidyReport",
          "icon": "uil-chart-line",
          "isTitle": false,
          "gate": "subsidy report access",
          "subItems": [],

        },
        {
          "label": "Compliance Report",
          "link": "/reports/complianceReportTable",
          "icon": "uil-file-check-alt",
          "isTitle": false,
          "gate": "compliance report access",
          "subItems": [],

        },
        {
          "label": "Food Court Report",
          "link": "/tables/foodcourtStatisticsTable",
          "icon": "fas fa-warehouse",
          "isTitle": false,
          "gate": "food-court report access",
          "subItems": [],

        },
        {
          "label": "Operational Report",
          "link": "/tables/operationalReportsForCorporate",
          "icon": "uil-chart-line",
          "isTitle": false,
          "gate": "operational report access",
          "subItems": [],

        },
        {

          "label": "Finance",
          "link": null,
          "icon": "uil-analytics",
          "isTitle": false,
          "gate": "finance access",
          "subItems": [
            {

              "label": "Finance Dashboard",
              "link": "/dashboard/financeDashboard",
              "gate": "view finance dashboard",
              "icon": "uil-analytics"
            },
            {

              "label": "Invoices",
              "link": "/tables/invoicesTable",
              "icon": "uil-invoice",
              "gate": "view invoice",
            }
          ],

        },
        {

          "label": "Sales Master",
          "link": "/tables/salesMixReport",
          "icon": "uil-chart-line",
          "isTitle": false,
          "subItems": [],
          "gate": "view sales master",
        },
        {
          "label": "Corporate Credit",
          "link": "/tables/creditLimitReport",
          "icon": "uil-card-atm",
          "isTitle": false,
          "subItems": [],
          "gate": "view corporate credit",
        },
        {
          "label": "Sodexo Reports",
          "link": "/tables/sodexo-reports",
          "icon": "uil-arrow-growth",
          "isTitle": false,
          "subItems": [],
          "gate": "view sodexo reports",

        },
        {
          "label": "Customers",
          "link": null,
          "icon": "uil-users-alt",
          "isTitle": false,
          "gate": "customer access",
          "subItems": [
            {
              "label": "View Customers",
              "link": "/tables/usersTable",
              "gate": "view customer"

            }
          ],

        },
        {
          "label": "Settlement Reports",
          "link": null,
          "icon": "uil-analytics",
          "isTitle": true,
          "gate": "settlement report access",
          "subItems": [
            {
              "label": "Generate Settlement Reports",
              "link": "/reports/generate_settlement_reports",
              "icon": "uil-analytics",
              "gate": "create settlement report",
            }
          ],

        },
        {
          "label": "Event Sales",
          "link": null,
          "icon": "uil-calendar-alt",
          "isTitle": true,
          "gate": "event sales access",
          "subItems": [
            {
              "label": "Add New Event",
              "link": "/event-sales/add-event",
              "gate": "create event sale",
            },
            {
              "label": "View Events",
              "link": "/event-sales/list",
              "icon": "uil-analytics",
              "gate": "view event sales",
            },
            // {
            //   "label": "Event Sales Report",
            //   "link": "/reports/generate_settlement_reports",
            //   "icon": "uil-analytics",
            //   "gate": "create settlement report",
            // }

          ],

        },
        {
          "label": "QR Sales Report",
          "link": "/tables/qr-sales-reports",
          "icon": "uil-qrcode-scan",
          "isTitle": false,
          "gate": "view qr sales report",
          "subItems": [],

        },
        {
          "label": "Pluxee Sales",
          "link": "/pluxee/pluxee-sales",
          "icon": "uil-credit-card",
          "isTitle": false,
          "gate": "view pluxee sales",
          "subItems": [],

        },
        {
          "label": "SmartWorks Sales",
          "link": "/tables/smartworks-sales",
          "icon": "uil-vertical-align-bottom",
          "isTitle": false,
          "gate": "view smartworks sales",
          "subItems": [],

        },
        {
          "label": "Pending Orders",
          "link": "/orders/pendingOrdersTable",
          "icon": "fas fa-business-time",
          "isTitle": false,
          "subItems": [],
          "gate": "view pending orders",
          "badge": {
            "text": 0,
            "class": "vsm--badge_default"
          }
        },
        {

          "label": "Cash Sales Report",
          "link": "/tables/cash-sales-reports",
          "gate": "view cash sales report",
          "icon": "uil-money-stack",
          "isTitle": false,
          "subItems": [],
        },
        {

          "label": "Daily Sales Report",
          "link": "/tables/dsr",
          "gate": "view dsr",
          "icon": "uil-chart-bar",
          "isTitle": false,
          "subItems": [],
        },
        {
          "label": "Others",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "others access"

        },
        {

          "label": "Miscellaneous",
          "link": "/form/miscellaneousForm",
          "gate": "miscellaneous access",
          "icon": "uil-file-plus-alt",
          "isTitle": false,
          "subItems": [],

        },
        {

          "label": "Cloudkitch Staff",
          "link": null,
          "gate": "cloudkitch staff access",
          "icon": "fas fa-users",
          "isTitle": false,
          "subItems": [
            {

              "label": "Add Employee",
              "link": "/form/cloudkitchEmployeeForm/:type",
              "gate": "create staff",

            },
            {

              "label": "View Employee",
              "link": "/tables/cloudkitchEmployeeTable",
              "gate": "list staff",

            }
          ],

        },
        {

          "label": "Banners",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "banners access"
        },
        {

          "label": "Add banner",
          "link": "/profile/bannerDetails",
          "icon": "uil-images",
          "isTitle": false,
          "subItems": [],
          "gate": "create banner"

        },
        {

          "label": "Feedback",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "feedback menu access",

        },
        {

          "label": "Feedbacks",
          "link": null,
          "icon": "fas fa-comments",
          "isTitle": false,
          "gate": "feedback access",
          "subItems": [
            {

              "label": "Add Feedback Template",
              "link": "/form/feedbackTemplate/:type",
              "gate": "create feedback template",

            },
            {

              "label": "View Feedback Templates",
              "link": "/tables/fdbackViewTemplates",
              "gate": "list feedback template"

            },
            {

              "label": "Feedback Report",
              "link": "/tables/feedbackMixReport",
              "gate": "view feedback report"

            },
            {

              "label": "Add Feedback Reason Groups",
              "link": "/form/feedback-reason-group",
              "gate": "create feedback reason group",
            },
            {

              "label": "View Feedback Reason Groups",
              "link": "/table/feedback-reason-group-table",
              "gate": "view feedback reason group"
            },
            {

              "label": "Schedule Feedback Report",
              "link": "/tables/scheduleFeedbackReport",
              "gate": "schedule feedback report"

            },
          ],

        },
        {

          "label": "Approvals",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "approval access",

        },
        {

          "label": "Approval Lists",
          "link": null,
          "icon": "uil-check-circle",
          "gate": "approval list access",
          "isTitle": false,
          "subItems": [
            {
              "label": "Principle List",
              "link": "/tables/principleApprovalTable",
              "icon": "bx bxs-buildings",
              "gate": "view principle approval list",
            },
            {
              "label": "Restaurant List",
              "link": "/tables/restaurantApprovalTable",
              "icon": "uil-home-alt",
              "gate": "view restaurant approval list"
            },
            {
              "label": "Food Menu List",
              "link": "/tables/foodMenuApprovalTable",
              "icon": "uil-restaurant",
              "gate": "view food menu approval list"
            },
            {
              "label": "Corporate List",
              "link": "/tables/corporateApprovalTable",
              "icon": "uil-bag",
              "gate": "view corporate approval list"
            }
          ],

        },
        {
          "label": "Order Approval",
          "link": "/tables/orderApprovalTable",
          "icon": "uil-check-circle",
          "isTitle": false,
          "gate": "order approval list",
          "subItems": [],

        },
        {

          "label": "Access Control",
          "link": null,
          "isTitle": true,
          "subItems": [],
          "gate": "access control access"
        },
        {
          "label": "Access Controls",
          "link": null,
          "icon": "uil-file-check-alt",
          "isTitle": true,
          "gate": "old acl",
          "subItems": [
            {
              "label": "Roles",
              "link": "/form/userAccessControl",
              "icon": "uil-home-alt"
            },

          ],
        },
        {
          "label": 'Roles & Permissions',
          "link": null,
          "icon": "dripicons-gear",
          "isTitle": true,
          "gate": "role and permission access",
          "subItems": [
            {
              "label": 'Roles',
              "link": '/roles',
              "gate": "list roles",
              // class: "menuSubTitle"
            },
            {
              "label": 'Permissions',
              "link": '/permissions',
              "gate": "list permissions"
              // class: "menuSubTitle"
            },
          ]
        }

      ]
    };
  },

  props: {
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true,
      default: "250px"
    }
  },
  components: {
    // simplebar,
  },
  mounted() {
    // let user = store.getters.loggedInUser;
    //
    // if(this.$ability.rules.length==0){
    this.getUserAbility();
    //  }
    // else {
    //   this.getMenu(user.login_type);
    // }
  },

  methods: {
    async getUserAbility() {
      if (localStorage.getItem('token')) {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem('token');
        this.axios.get('abilities').then(response => {
          this.$ability.update([
            {action: response.data.data, subject: 'all'}
          ]);
          this.getMenu(store.getters.loggedInUser.login_type);
        });

      }
    },
    getMenu(loginTypeID) {
      var menuObjects;
      this.menu = [
        (menuObjects = {
          title: store.getters.loggedInUser.name,
          icon: "dripicons-gear",
          child: [
            // {
            //   title: "Settings",
            //   class: "menuSubTitle"
            // },
            {
              title: "Reset Password",
              href: "/auth/recoverpwd/" + loginTypeID,
              class: "menuSubTitle"
            },
            {
              title: "Logout",
              href: "/logout",
              class: "menuSubTitle"
            }
          ],
          class: "menuTitle"

        })

      ];
      for (var i = 0; i < this.menuData.length; i++) {
        if (this.menuData[i].subItems.length > 0) {
          var child = [];
          for (var x = 0; x < this.menuData[i].subItems.length; x++) {

            var tempChildObj = {
              href: this.menuData[i].subItems[x].link,
              title: this.menuData[i].subItems[x].label,
              class: "menuSubTitle"
            };
            if (this.menuData[i].subItems[x].gate === undefined || this.$ability.can(this.menuData[i].subItems[x].gate)) {
              child.push(tempChildObj);
            }
          }
          if (child.length > 0) {
            menuObjects = {
              title: this.menuData[i].label,
              icon: this.menuData[i].icon,
              child: child,
              class: "menuTitle"
            };
          }

        } else if (this.menuData[i].isTitle == true) {
          menuObjects = {
            title: this.menuData[i].label,
            class: "menuHeader"
          };
        } else {
          menuObjects = {
            href: this.menuData[i].link,
            title: this.menuData[i].label,
            icon: this.menuData[i].icon,
            class: "menuTitle"
          };
        }
        if (this.menuData[i].gate === undefined || this.$ability.can(this.menuData[i].gate)) {
          this.menu.push(menuObjects);
        }

      }

    },

  }
};
</script>

<template>
  <sidebar-menu :menu="menu" class="scroll" theme="white-theme"/>
</template>

<style>
.v-sidebar-menu {
  width: 250px;
}

::-webkit-scrollbar {
  width: 3px !important;
  background-color: #f5f5f5 !important;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px !important;
  background-color: #e0e0e0 !important;
  border: 2px solid #e0e0e0 !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded
.vsm--item_open
.vsm--link_level-1 {
  background-color: #f7e7e5 !important;
  color: #f3766a !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded
.vsm--item_open
.vsm--link_level-1
.vsm--icon {
  color: #f3766a !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded
.vsm--item_open
.vsm--link_level-1
.vsm--icon {
  background-color: #bbc5d6;
  color: #1e1e21;
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active {
  box-shadow: none;
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1 .vsm--icon {
  background-color: transparent !important;
}

.menuTitle {
  color: #7b8190 !important;
  position: relative !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  transition: all 0.4s !important;
  margin: 0 10px !important;
  border-radius: 3px !important;
}

.v-sidebar-menu.vsm_white-theme
.vsm--link_level-1.vsm--link_exact-active
.vsm--icon,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active .vsm--icon {
  color: #f3766a !important;
}

.menuSubTitle {
  padding: 6px 24px 6px 51px !important;
  font-weight: 400 !important;
  color: #7b8190 !important;
  margin: 0 !important;
  background-color: transparent !important;
  font-size: 14px !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--dropdown .vsm--list {
  background-color: transparent;
}

.v-sidebar-menu .vsm--link_exact-active,
.v-sidebar-menu .vsm--link_active {
  color: #f3766a !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--toggle-btn {
  display: none !important;
}

.menuHeader {
  letter-spacing: 0.05em !important;
  pointer-events: none !important;
  cursor: default !important;
  font-size: 11px !important;
  text-transform: uppercase !important;
  color: #f3766a !important;
  font-weight: 600 !important;
}

td,
th {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

/* padding:0.7rem 0.5rem !important; */

.multiselect__select {
  z-index: 1;
}

.table th {
  text-align: center;
  min-width: 100px;
  white-space: normal;
  vertical-align: middle;
}

.table > :not(caption) > * > * {
  padding: 0.25rem 0.3rem !important;
}

.multiselect__content-wrapper {
  width: fit-content;
  min-width: 100%;
}

.multiselect__tags {
  height: 38px !important;
  overflow: auto !important;
}

.pagination-rounded .page-link {
  width: auto !important;
  min-width: 40px !important;
}
</style>
